import { net_common } from "@/api/http";
export const API_ToPDF = (...params) =>
  net_common.post("/api/STDSDC01C08/ToPDF", ...params)

export const API_DisplayFileConfirmationScreen = (...params) =>
  net_common.post("/api/STDSDC01C08/DisplayFileConfirmationScreen", ...params)

export const API_UpdateStatus = (...params) =>
  net_common.post("/api/STDSDC01C08/UpdateStatus", ...params)
